import { useQuery } from '@tanstack/react-query'

import axios from '@/_lib/axiosInstance'
import { ApiResponse, IPreventiveExaminationCategory } from '@/_types'

/**
 * Fetches a preventive examination category by slug (includes examination list for GA4 mapping).
 */
export const fetchPreventiveExaminationCategory = async (
	slug: string
): Promise<ApiResponse<IPreventiveExaminationCategory>> => {
	return axios
		.get<ApiResponse<IPreventiveExaminationCategory>>(
			`v1/web/preventiveExamination/categories/${slug}`
		)
		.then(res => res.data)
}

/**
 * @param slug - Category slug (`zeny` | `muzi`).
 * @param enabled - When false, the query does not run.
 */
export const useGetPreventiveExaminationCategory = (slug: string, enabled = true) => {
	return useQuery<ApiResponse<IPreventiveExaminationCategory>>({
		queryKey: ['preventive-examination-category', slug],
		queryFn: () => fetchPreventiveExaminationCategory(slug),
		enabled: enabled && slug.length > 0,
		select: data => data
	})
}
